/**
 * éä½æ¹æ³ï¼åæ¶åªåè®¸ä¸ä¸ªå®ä¾è¿è¡
 * @param timeout
 */
import {OnDestroy} from "@angular/core";

export function lockMethod(timeout = 1000) {
    return function (target, propertyKey: string, descriptor: PropertyDescriptor) {
        const queue = _getQueue(target, propertyKey, descriptor);
        queue.lockTimer = timeout;
        queue.isLock = true;
    }
}

/**
 * ç¯ç»æ¹æ³
 */
export function aroundMethod(...method) {
    return function (target, propertyKey: string, descriptor: PropertyDescriptor) {
        const queue = _getQueue(target, propertyKey, descriptor);
        queue.around.push(...method);
    }
}

/**
 * æ¹æ³å¼å§è°ç¨æ¶æ§è¡
 * @param method
 */
export function beforeMethod(...method) {
    return function (target, propertyKey: string, descriptor: PropertyDescriptor) {
        const queue = _getQueue(target, propertyKey, descriptor);
        queue.before.push(...method);
    }
}

/**
 * æ¹æ³è°ç¨å®æåç«å³æ§è¡
 * @param method
 */
export function afterMethod(...method) {
    return function (target, propertyKey: string, descriptor: PropertyDescriptor) {
        const queue = _getQueue(target, propertyKey, descriptor);
        queue.after.push(...method);
    }
}

/**
 * æ¹æ³æ§è¡å®æåæ§è¡(å¦ promise å®æå)
 * @param method
 */
export function finishedMethod(...method) {
    return function (target, propertyKey: string, descriptor: PropertyDescriptor) {
        const queue = _getQueue(target, propertyKey, descriptor);
        queue.finished.push(...method);
    }
}

/**
 * å½æ¹æ³åçå¼å¸¸æ¶è§¦å
 * @param method
 */
export function throwMethod(...method) {
    return function (target, propertyKey: string, descriptor: PropertyDescriptor) {
        const queue = _getQueue(target, propertyKey, descriptor);
        queue.throw.push(...method);
    }
}

/**
 * ä½¿ç¨æ­¤æ³¨è§£ï¼æ¹æ³åªä¼è°ç¨ä¸æ¬¡ï¼ä»¥åé½åªä¼è¿åå®çè¿åå¼
 */
export function cacheMethod() {
    return function (target, propertyKey: string, descriptor: PropertyDescriptor) {
        const queue = _getQueue(target, propertyKey, descriptor);
        queue.isCache = true;
    }
}

export const Aspect = {
    beforeMethod,
    afterMethod,
    throwMethod,
    aroundMethod,
    finishedMethod,
    cacheMethod,
    lockMethod
};

const symbol = `__aop__`;

function _addAop(prototype, methodName: string, descriptor: PropertyDescriptor) {
    const source = descriptor.value;
    const queue = _createQueue();
    descriptor.value = function (...args) {
        if (queue.isCache) { // è¥è®¾ç½®äºç¼å­
            if (queue.cached && _eq(queue.cacheParam, args)) { // è¥æ¹æ³å·²è°ç¨ï¼å¹¶ä¸åæ°æªåçååï¼ç´æ¥è¿åç¼å­çè¿åå¼
                return queue.cacheValue;
            }
            queue.cacheParam = args;
        }
        if (queue.isLock && queue.isCalling) { // è¥å­å¨æ¹æ³éï¼åå¨ isCalling æ¶ï¼ä¸åæ§è¡æ¹æ³ä½
            return queue.promise;
        }
        queue.isCalling = true;

        // beforeMethod æ¹æ³æ§è¡å å¯è°æ´argsåæ°
        _runQueues(queue, 'before', this, args, methodName);

        try {
            // å¼å§è°ç¨æ¹æ³
            queue.promise = source.apply(this, args);
        } catch (e) {
            // æ¹æ³åçå¼å¸¸æ¶
            const res = _runQueues(queue, 'throw', this, args, methodName, e);
            _runQueues(queue, 'after', this, args, methodName);
            queue.isCalling = false;
            if (res === false) {// è¥throw è¿åå¼ä¸º falseï¼ååæ­¢æåºå¼å¸¸
                return;
            }
            throw e; // å¦åæ­£å¸¸æåºå¼å¸¸
        }

        // afterMethod æ¹æ³è°ç¨å
        _runQueues(queue, 'after', this, args, methodName, queue.promise);

        if (queue.promise && queue.promise.then && queue.promise.catch) {
            queue.promise.then(() => {
                // finishedMethod å½å¼æ­¥æ¹æ³å®æåè§¦å
                _runQueues(queue, 'finished', this, args, methodName, queue.promise);
                queue.isCalling = false;
            });
            queue.promise.catch((err) => {
                // finishedMethod å½å¼æ­¥æ¹æ³å¼å¸¸åè§¦å
                _runQueues(queue, 'throw', this, args, methodName, err);
                queue.isCalling = false;
                queue.cached = false;
            });
        } else if (queue.isLock) {
            setTimeout(() => {
                // finishedMethod å½å­å¨æ¹æ³éæ¶ï¼å¯è®¾ç½®å»¶æ¶è§¦å
                _runQueues(queue, 'finished', this, args, methodName, queue.promise);
                queue.isCalling = false;
            }, queue.lockTimer);
        } else {
            // finishedMethod æ¹æ³è°ç¨å®æåè§¦å
            _runQueues(queue, 'finished', this, args, methodName, queue.promise);
            queue.isCalling = false;
        }

        // æ¹æ³å·²è°ç¨ï¼ä»¥åè°ç¨åæ°ç¼å­
        queue.cached = true;
        queue.cacheValue = queue.promise;

        return queue.promise;

    };
    Object.defineProperty(descriptor.value, symbol, {value: queue});
    Object.defineProperty(prototype, methodName, descriptor);
    _bindDestroy(prototype);
}

function _getQueue(prototype, propertyKey: string, descriptor: PropertyDescriptor): Queue {
    if (!descriptor.value[symbol]) {
        _addAop(prototype, propertyKey, descriptor);
    }
    return descriptor.value[symbol];
}

function _createQueue(): Queue {
    return {
        before: [], // è°ç¨åæ§è¡(å¯è°æ´åæ°)
        throw: [], // å½æå¼å¸¸æ¶æ§è¡
        around: [], // ç¯ç»éç¥

        isCalling: false,
        called: false,

        isCache: false,
        cacheValue: void 0,

        isLock: false,
        lockTimer: 0,

        after: [], // è°ç¨åç«å³æ§è¡
        finished: [] // å®å¨å®æåæè°ç¨
    }
}

interface Queue {
    before: any[]
    after: any[]
    finished: any[]
    around: any[]
    throw: any[]

    isCache: boolean
    isCalling: boolean
    isLock: boolean
    lockTimer: number

    [key: string]: any
}

function _runQueues(queue: Queue, name: 'before' | 'after' | 'finished' | 'throw', target, ...args) {
    __invoke(queue.around, target, name, ...args);
    return __invoke(queue[name], target, ...args);
}

function __invoke(list: any[], target, ...args) {
    let res;
    for (let i = 0; i < list.length; i++) {
        const method = list[i];
        if (typeof method === 'string' && typeof target[method] === 'function') {
            res = target[method].apply(target, args);
        } else if (typeof method === 'function') {
            res = method.apply(target, args);
        }
    }
    return res;
}

function _eq(a, b) {
    for (let i = 0; i < a.length; i++) {
        const element = a[i];
        if (element !== b[i]) {
            return false;
        }
    }
    return true;
}

// éè¦å¤çdestroyç¶æ
function _bindDestroy(prototype: OnDestroy) {
    const source = prototype.ngOnDestroy;
    const key = '__aop_destroy__';
    if (!source || !source[key]) {
        prototype.ngOnDestroy = function () {
            Object.keys(prototype).forEach(key => {
                if (typeof prototype[key] === 'function' && prototype[key][symbol]) {
                    const queue: Queue = prototype[key][symbol];
                    // åå§ååæ°ç¼å­å¨ï¼é²æ­¢å¯¹è±¡åå­æ³æ¼
                    queue.promise = queue.cacheParam = null;
                    queue.cached = false;
                }
            });
            source && source.call(this);
        };
        prototype.ngOnDestroy[key] = 1;
    }
}
